// extracted by mini-css-extract-plugin
export var highlightFade = "_33-4";
export var highlighted = "_33-3";
export var table = "_33-1";
export var tableContainer = "_33-0";
export var totalsRow = "_33-2";